module.exports = __webpack_public_path__ + "img/KM-360A_14.eb566b27.jpg";